import {krzysztofJaniszewski} from "../../people/krzysztof_janiszewski";

export const psychodynamicPsychotherapy = {
    'meta': {
        'title': 'Psychoterapia psychodynamiczna | Blog | COLLIGO',
        'description': 'Przegląd psychoterapii psychodynamicznej, jej korzeni, technik, efektywności oraz współczesnych kierunków. Zrozum głębsze aspekty tej metody i jej znaczenie w dzisiejszej psychoterapii.'
    },
    'title': 'Psychoterapia psychodynamiczna',
    'date': '2023-10-14',
    'readingTime': 10,
    'author': krzysztofJaniszewski,
    'url': {
        'address': '/blog/psychoterapia-psychodynamiczna/',
        'title': 'Psychoterapia psychodynamiczna | Blog | COLLIGO',
        'name': 'Psychoterapia psychodynamiczna'
    },
    'image': {
        'url': '/images/blog/psychoterapia-psychodynamiczna.webp',
        'width': 886,
        'height': 295,
        'alt': 'Diagnostyka autyzmu'
    },
    'opengraph': {
        'image': {
            'url': '/images/blog/open-graph/psychoterapia-psychodynamiczna.webp',
            'width': 150,
            'height': 150,
            'alt': 'Przegląd psychoterapii psychodynamicznej, jej korzeni, technik, efektywności oraz współczesnych kierunków. Zrozum głębsze aspekty tej metody i jej znaczenie w dzisiejszej psychoterapii.'
        }
    }
}